const AgriLogistics = () => {
    return (
    <div>
      <div className="">
        <img src="/logisticsBanner/banner-11.jpg" width="100%"/>
      </div>
      <div className="flex flex-col justify-center items-center mb-[1.5rem]">
        <hr className="w-[52rem]"/>
        <div className="lg:flex md:grid flex-1 justify-center items-start mx-auto max-w-[60rem] my-[5rem] gap-5 ">
    
          <div className="flex flex-col justify-center">
              <h1 className="font-bold text-3xl text-[#373737]">
                Agri Logistics
              </h1>
              <p className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
                For companies producing crops, it can be difficult to keep track of all logistics. 
                Crops are alive and therefore require totally different management of the logistics 
                than non-perishable goods. In agricultural productions, it is very important to prevent 
                spoilage and keep track of the quality. Tracking and tracing and just-in-time delivery 
                are essential in this business. 
              </p>
              <p className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
                Shipping farm equipment has unique logistics challenges that require special teams, 
                trucks, and trailers. When logistics professionals need to move oversized and heavyweight 
                farm equipment or expedite a critical tractor part, they heavily rely on TCS Logistics. 
                Our agriculture transport specialists partner with our client’s team to identify downtime 
                risks, and ensure uptime. We have over three decades of experience shipping farm equipment 
                to remote locations on the tightest deadlines. 
              </p>
              <p className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
                TCS Logistics is working with small family farms as well as larger agricultural processors,
                manufacturers, and distributors looking to expedite their critical parts and farm equipment shipping. 
              </p>
          </div>
          <div className="flex-1 flex flex-col justify-center items-center">
            <img src="/Home/trainingdevelop/traning-1.jpg" alt="" className="max-w-[45rem] h-[30vh]"/>
          </div>
        </div>
      
      </div>
    </div>

    )
};
export default AgriLogistics;